import { PublicKey } from "@solana/web3.js";

import { AllowedEnv, DEFAULT_API_VERSION, ENVIRONMENTS, EnvDetails, SERVICE_API_VERSIONS } from "./env";

type AllowedDevEnv =
    | AllowedEnv.Dev
    | AllowedEnv.ProdTesting
    | AllowedEnv.FeatureStaging
    | AllowedEnv.Sandbox
    | AllowedEnv.LocalNet;

export const IS_LOCAL_NX_DEV = process.env.NX_TASK_TARGET_CONFIGURATION === "development";

export const DEBUG = IS_LOCAL_NX_DEV;

const cloudEnvRaw = process.env.NX_ENVIRONMENT;
const cloudEnv =
    cloudEnvRaw && Object.values(AllowedEnv).includes(cloudEnvRaw as AllowedEnv)
        ? (cloudEnvRaw as AllowedEnv)
        : undefined;

// Modify this
const devEnv: AllowedDevEnv = AllowedEnv.ProdTesting;

// Do not modify
const env: AllowedEnv = (() => {
    // prevents bad AWS deploys in prod
    if (window.location.origin.includes("prime.loopscale")) return AllowedEnv.Main;
    if (window.location.origin.includes("alpha.loopscale")) return AllowedEnv.Sandbox;

    if (IS_LOCAL_NX_DEV) return devEnv;

    return cloudEnv ?? AllowedEnv.Main;
})();

export const ENV_DETAILS: EnvDetails = ENVIRONMENTS[env];

export const BRIDGESPLIT_TS_API = "https://bridgesplit-backend-vmyhi2huoa-uc.a.run.app/";
export const ABF_API = ENV_DETAILS.abfApi;
export const PRICING_API = ENV_DETAILS.externalPricesApi;
export const MESSAGING_API = ENV_DETAILS.messagingApi;
export const IDENTITY_API = ENV_DETAILS.identityApi;
export const BS_METADATA_API = ENV_DETAILS.bsMetadataApi;
export const SYNDICATED_API = ENV_DETAILS.syndicatedApi;
export const ZEPHYR_API = ENV_DETAILS.zephyrApi;
export const MPC_API = ENV_DETAILS.mpcApi;
export const CAVEMAN_API = ENV_DETAILS.cavemanApi;
export const RUBICON_API = ENV_DETAILS.rubiconApi;
export const TYGRIS_API = ENV_DETAILS.tygrisApi;
export const NAPOLEON_API = ENV_DETAILS.napoleonApi;
export const ARRAKIS_API = ENV_DETAILS.arrakisApi;
export const RUBY_API = ENV_DETAILS.rubyApi;
export const ORACLES_API = ENV_DETAILS.oraclesApi;
export const PANDORA_API = ENV_DETAILS.pandoraApi;

export const IS_LOCAL_NET = env === AllowedEnv.LocalNet;
export const IS_PROD = env === AllowedEnv.Main;
export const IS_SANDBOX = env === AllowedEnv.Sandbox;

export const RPC_URL =
    ENV_DETAILS.rpcUrl ??
    process.env.RPC_URL ??
    "https://mainnet.helius-rpc.com/?api-key=22f1c508-dce2-4d82-876e-53d416bfbd3e";
export const ABF_PID = new PublicKey(ENV_DETAILS.abfPid);
export const LIQUIDATION_PID = new PublicKey(ENV_DETAILS.liquidationPid);

export const SYNDICATED_PID = new PublicKey(ENV_DETAILS.syndicatedPid);

// Sphere's app ID. Fine to expose publicly
export const TELLER_APP_ID = "app_oo7bqp4gqthrcviih8000";

export const doesApiVersionMatch = (endpoint: string, headerVersion: string) => {
    const endpointKey = Object.entries(ENV_DETAILS).find(([, basePath]) => endpoint.includes(basePath))?.[0];

    // if unmatched api, version is always compatible
    if (!endpointKey) {
        return true;
    }
    const apiVersion = SERVICE_API_VERSIONS[endpointKey as keyof typeof SERVICE_API_VERSIONS] ?? DEFAULT_API_VERSION;

    return apiVersion === headerVersion;
};
